import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from '../../components/Header'; 
import { FiMenu } from "react-icons/fi"; 

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#F5F7FA] relative">
      <Header />
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/60 z-30 lg:hidden transition-opacity"
          onClick={() => setSidebarOpen(false)} 
        />
      )}
      
      <div className="flex items-start max-w-[1400px] mt-4 mx-auto relative px-4">
        {/* Sidebar */}
        <Sidebar
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)} 
        />
        
        <main className="flex-1 w-full lg:w-[1052px]">
          <div className="lg:hidden mb-3">
            <button 
              onClick={() => setSidebarOpen(true)}
              className="flex items-center gap-2 bg-white text-[#333333] px-4 py-3 rounded-[8px] shadow-sm border border-gray-200 hover:text-[#E63946] transition-colors"
            >
              <FiMenu className="text-[24px]" />
              <span className="font-poppins font-medium text-[16px]">Menu</span>
            </button>
          </div>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;